import { render, staticRenderFns } from "./PIreorcd.vue?vue&type=template&id=22edb942&scoped=true"
import script from "./PIreorcd.vue?vue&type=script&lang=js"
export * from "./PIreorcd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22edb942",
  null
  
)

export default component.exports